import { render, staticRenderFns } from "./ForgotPasswordDisclosure.vue?vue&type=template&id=34af89ac&scoped=true&"
import script from "./ForgotPasswordDisclosure.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordDisclosure.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordDisclosure.vue?vue&type=style&index=0&id=34af89ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af89ac",
  null
  
)

export default component.exports